import { useMemo } from 'react';

import { useCurrentOrganization } from '@/modules/core';
import { getIdsFromPath } from '@/utils';

const useGetCurrentEmployerId = () => {
  const { observingEmployer, observingOrganization } = useCurrentOrganization();
  const { employerId: forceEmployerId } = useMemo(
    () => getIdsFromPath(observingOrganization.path),
    [observingOrganization.path]
  );
  return observingEmployer?.id || forceEmployerId;
};

export default useGetCurrentEmployerId;
